import { logStartUsage } from 'owa-analytics-start';
import type RetryStrategy from 'owa-shared-start/lib/interfaces/RetryStrategy';
import { type ErrorRetryStrategy } from 'owa-shared-start/lib/interfaces/ErrorRetryStrategy';
import { addQueryStringParameterForRedirect } from 'owa-shared-start/lib/doErrorRetryRedirect';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isAttendeePath } from './isAttendeePath';

export default function overrideRetryStrategy(
    bootResult: string | undefined
): RetryStrategy | null {
    if (bootResult == 'errorfe' || bootResult == 'configuration') {
        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
         * BASELINE: DO NOT COPY/PASTE!
         *	> Argument at index 1 for logStartUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
        logStartUsage('BookWithMeOverrideRetryStrategy', undefined, { bootResult });
        const userConfig = getUserConfiguration();
        let isOnPrem = false;

        try {
            isOnPrem = userConfig?.SessionSettings?.IsSPOnPrem ?? true;
        } catch {
            isOnPrem = true;
        }
        const isAttendeePage = isAttendeePath();

        if (isAttendeePage) {
            addQueryStringParameterForRedirect('anonRetry', '');
            if (isOnPrem) {
                /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
                 * BASELINE: DO NOT COPY/PASTE!
                 *	> Argument at index 1 for logStartUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
                logStartUsage('BookWithMeOnPremiseUser', undefined);
            } else {
                /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
                 * BASELINE: DO NOT COPY/PASTE!
                 *	> Argument at index 1 for logStartUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
                logStartUsage('BookWithMeNonOnPremiseUser', undefined);
            }
        } else if (bootResult == 'configuration' && !isAttendeePage) {
            // shortcut out if there is a configuration error not on an attendee page
            // in that case, we want the default behavior to kick in.
            return null;
        }
        return { strategy: '1' };
    }
    return null;
}
